/** `?tab=` values understood by the admin Partner Program page. */
export const PARTNER_PROGRAM_BENEFITS_LOG_TAB = "benefits-log";

export const PARTNER_PROGRAM_TAB_INDEX_BY_KEY: Record<string, number> = {
  "performance-trend": 0,
  overview: 1,
  calculator: 2,
  [PARTNER_PROGRAM_BENEFITS_LOG_TAB]: 3,
};
